import { apiClient } from "./apiClient";

export const harvestsApi = {
  list: (params) => apiClient.get("/harvests", { params }).then((r) => r.data),
  create: (payload) => apiClient.post("/harvests", payload).then((r) => r.data),
  // A real delete, not a soft flag: a mistyped harvest is a wrong number
  // in every total rather than history worth keeping (#250).
  //
  // It is no longer true that "a harvest row is referenced by nothing",
  // as this comment used to say -- V091 links honey harvests to a pool
  // movement, and the server takes that credit back out on delete, or
  // refuses with a 409 when the honey has since been bottled.
  remove: (harvestId) => apiClient.delete(`/harvests/${harvestId}`).then((r) => r.data),
};
